/* import __COLOCATED_TEMPLATE__ from './power-supply-ripple.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';

import Utils from '../../../utils/utils';

export default class PowerSupplyRipple extends Component {
  @service validationService;
  @service('aditools-analytics') analytics;

  @action handlePowerSupplyRippleChange(value) {
    this.args.model.signalChainHandler.dac.data.powerSupplyRipple = value;

    if (this.args.updateAppData) this.args.updateAppData();

    this.analytics.setWebEvent(
      Utils.getToolName(),
      'setPowerSupplyRipple',
      `${this.args.model.signalChainHandler.dac.data.powerSupplyRipple}`,
    );
  }
}
